import React from "react";

// import ErrorIcon from "@common/assets/images/error.png";
// import { ReactComponent as WarningIcon } from "@common/assets/images/warning.svg";
import Heading from "@common/components/Heading/Heading";
import HorizontalBar from "@common/components/HorizontalBar/HorizontalBar";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import { vars } from "@common/styles";
import { docLink } from "@common/util/docs";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import useEndpointHealthData from "@main/pages/Release/consumers/useEndpointHealthData";
import { MetricCardEmptyState } from "@main/pages/Release/views/MetricCards/MetricCardEmptyState";
import { EndpointUrl } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl";
import * as Styled from "main/pages/Release/views/MetricDetails/EndpointHealth/EndpointHealthDataView.styles";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function EndpointHealthDataView() {
  const { endpoints, isLoading } = useEndpointHealthData();

  const { selectedApp } = useAppSelectionContext();
  const platform = selectedApp?.platform?.name;

  const isEmpty = !endpoints || endpoints.length === 0;

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Data
        </Heading>
        <Paragraph
          p1
          style={{ marginBottom: "2.4rem" }}
        >
          All endpoints are listed below, sorted from the worst score to the best.
        </Paragraph>
        {!isEmpty ? (
          <Styled.EndpointList>
            {endpoints?.map((endpoint, index) => (
              <Styled.EndpointRow key={`${endpoint.method}-${endpoint.url}-${index}`}>
                <Styled.EndpointScore score={endpoint.score} />
                <HorizontalBar
                  style={{ width: "18rem", marginLeft: "1.6rem", marginRight: "1.6rem" }}
                  data={endpoint.barItems}
                />
                <div style={{ marginRight: "0.8rem" }}>
                  <Styled.MethodBadge
                    style={endpoint.isError ? { borderColor: "#EB57574D", color: vars.colors.red } : undefined}
                  >
                    {endpoint.method}
                  </Styled.MethodBadge>
                </div>

                {/*{endpoint.isError ? (*/}
                {/*  <Styled.ErrorIconWrapper>*/}
                {/*    <img*/}
                {/*      src={ErrorIcon}*/}
                {/*      alt="error"*/}
                {/*    />*/}
                {/*  </Styled.ErrorIconWrapper>*/}
                {/*) : (*/}
                {/*  endpoint.hasWarning && (*/}
                {/*    <Styled.WarningIconWrapper>*/}
                {/*      <WarningIcon />*/}
                {/*    </Styled.WarningIconWrapper>*/}
                {/*  )*/}
                {/*)}*/}
                <EndpointUrl
                  url={endpoint.url}
                  isError={endpoint.isError}
                />
              </Styled.EndpointRow>
            ))}
          </Styled.EndpointList>
        ) : (
          <MetricCardEmptyState
            text={"No network traffic recorded yet. If you haven't already, enable it in your SDK."}
            buttonText={"Enable network traffic"}
            onButtonClick={() => window.open(docLink(platform).networkTraffic, "_blank")?.focus()}
            column
          />
        )}
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
